import React, { useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import format from 'date-fns/format';

import { Container } from './styles';

import useIsMobile from 'hooks/useIsMobile';

const statusLabel = {
  UNREAD: 'Não lido',
  READ: 'Lido',
  PROCESSED: 'Processado',
};

const maxLength = 250;

function SubpoenaItem({
  id,
  journalName,
  availabilityDate,
  status,
  header,
  footer,
  treatmentDate,
  publicationNumber,
  fileNumber,
  title,
  text,
  isLabor,
  onSelectClick,
  onProcessClick,
  onSeeMoreClick,
  isSelected,
}) {
  const [seeMore, setSeeMore] = useState(false);
  const isMobile = useIsMobile();

  const statusComponent = (
    <span className="status-label">{statusLabel[status]}</span>
  );

  const checkboxComponent = (
    <Checkbox checked={isSelected} onClick={() => onSelectClick(id)} />
  );

  const journalNameComponent = (
    <span className="infos__journal">{journalName}</span>
  );

  return (
    <Container status={status}>
      {!isMobile ? (
        checkboxComponent
      ) : (
        <div className="infos-mobile">
          {checkboxComponent}
          {journalNameComponent}
          {statusComponent}
        </div>
      )}

      <div className="infos-container">
        <div className="infos">
          {!isMobile && journalNameComponent}
          <span className="infos__availability">
            Disponibilização: {format(new Date(availabilityDate), 'dd/MM/yy')}
          </span>
          {!isMobile && statusComponent}
        </div>
        <div className="infos">
          {header && (
            <span className="infos__item">
              <b>Cabeçalho</b>: {header}
            </span>
          )}
          {footer && (
            <span className="infos__item">
              <b>Rodapé</b>: {footer}
            </span>
          )}
          <span className="infos__item">
            <b>N. publicação</b>: {publicationNumber}
          </span>
          <span className="infos__item">
            <b>N. arquivo</b>: {fileNumber}
          </span>
          <span className="infos__item last">
            <b>Tratamento</b>: {format(new Date(treatmentDate), 'dd/MM/yy')}
          </span>
        </div>

        <h3 className="title">
          <b>Título</b>: {title}
        </h3>

        <div>
          <span
            dangerouslySetInnerHTML={{
              __html: text.substr(0, seeMore ? text.length : maxLength),
            }}
          />

          {!seeMore && text.length > maxLength && <span>...</span>}
        </div>

        <span
          className="see-more"
          onClick={() => {
            setSeeMore(prev => {
              const isRead = !prev;

              if (isRead) {
                onSeeMoreClick(id);
              }

              return isRead;
            });
          }}
        >
          {seeMore ? 'Ver menos -' : 'Ver mais +'}
        </span>

        {isLabor && (
          <button
            className="process"
            onClick={() => {
              onProcessClick(id);
            }}
          >
            Processar
          </button>
        )}
      </div>
    </Container>
  );
}

export default SubpoenaItem;
